module.exports = __webpack_public_path__ + "img/CellCycle-PDAC_GSE202740.d7242b92.png";